import { ReasonInput } from '@strata/react-compound-inputs';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { accept999 } from 'api/medbillingAPI';
import { handleError } from 'services/Error';
import { useRefetchAllClaimDetails } from 'store/api/medbillingApi';

const Title = 'Update 999 Status';

const ReasonOptions = ['Confirmed with Payer', 'Payer Error', 'Processing Issue'];

const ValidationSchema = Yup.object({ ...ReasonInput.validationSchema });

interface Update999StatusDialogProps {
    onClose: () => void;
    payerId: string;
    transactionId: string;
}

export const Update999StatusDialog = ({
    onClose,
    payerId,
    transactionId,
}: Update999StatusDialogProps) => {
    const refetchAllClaimDetails = useRefetchAllClaimDetails({
        payerId,
        transactionId,
    });
    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={ValidationSchema}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await accept999({
                        transactionId,
                        payerId,
                        ...ReasonInput.submitValues(values),
                    });

                    refetchAllClaimDetails();

                    SuccessToast({ message: '999 status updated to accepted.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to update 999 status. Please try again.', err as Error);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Update Status"
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action will update the status of the 999 to accepted.
                            </div>
                            <ReasonInput reasons={ReasonOptions} />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

Update999StatusDialog.Title = Title;
